
import {useStore} from 'vuex'
import {ref,reactive,watch,onMounted} from 'vue'

export default function(formConfigGenerator,mountedCall,props){

    const store = useStore()
    const formConfig = reactive(formConfigGenerator(store,props.fields,props.countryList))

    const validateForm = function(form){
        let formIsComplete = null
        let requiredFieldCount = 0
        let validRequiredFieldCount = 0

        form.forEach((field)=>{
            let valid = false
            if (field.validator) {
                valid = field.type === 'select'
                            ? field.validator(field.value, field.options)
                            : field.validator(field.value)
            }
             const compareWith = form.find((compareField)=>{
                return compareField.name === field.compareTo
            })

            if(compareWith){
                valid = !!(valid && compareWith.value === field.value)
            } 

            field.valid = valid
            validRequiredFieldCount = field.valid && field.required ? validRequiredFieldCount+1 : validRequiredFieldCount
            requiredFieldCount = field.required ? requiredFieldCount+1 : requiredFieldCount 
        })

        formIsComplete = requiredFieldCount === validRequiredFieldCount

        store.dispatch('ecom/completeCheckoutForm',{
            name: props.formName,
            ready: formIsComplete,
            form
        })
        
    }
    
    const copyForm = function(){
        const thisFormName = props.formName
        const origin = store.state.ecom.checkout_forms.find(checkoutForm => checkoutForm.name !== thisFormName)

        if(origin && origin.form){
            origin.form.forEach(originalField => {
                const thisField = formConfig.find(currentFormField => currentFormField.name === originalField.name)
                thisField.value = originalField.value
            })
        }
    }

    const getLabel = (labelRequested) => {
        return store.getters['labels/getLabel'](labelRequested)
    }

    watch(formConfig,validateForm,{deep:true})

    onMounted(()=>{        
        store.commit('ecom/register_checkout_form',{
            name: props.formName
        })
        validateForm(formConfig)

        if(typeof mountedCall === 'function') mountedCall(store.state.ecom)
    })

    return {
        formConfig,
        copyForm,
        getLabel
    }
}